import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';
import { MultiScoreItem, ScoreDataGridRow, ScoreTableRow } from '@Types';
import {
	DataGridStateChange,
	RiskScoreChange,
	RiskValueChange,
} from '@Reducers/util.reducer';

export const setRiskScores = createAction<number[]>(
	addNamespace('Util/setRiskScores'),
);

export const setRiskEditScores = createAction<string[]>(
	addNamespace('Util/setRiskEditScores'),
);

export const setRiskUnitScores = createAction<number[] | undefined>(
	addNamespace('Util/setRiskUnitScores'),
);

export const setRiskScoreTable = createAction<ScoreTableRow[]>(
	addNamespace('Util/setRiskScoreTable'),
);

export const setRiskScoreDataGrid = createAction<ScoreDataGridRow[]>(
	addNamespace('Util/setRiskScoreDataGrid'),
);

export const setRiskMultiScoreDataGrid = createAction<MultiScoreItem[]>(
	addNamespace('Util/setRiskMultiScoreDataGrid'),
);

export const updateRiskMultiScoreDataGridRow = createAction<MultiScoreItem>(
	addNamespace('Util/updateRiskMultiScoreDataGridRow'),
);

export const updateRiskScoreDataGrid = createAction<RiskScoreChange>(
	addNamespace('Util/updateRiskScoreDataGrid'),
);

export const updateRiskValuesDataGrid = createAction<RiskValueChange[]>(
	addNamespace('Util/updateRiskValuesDataGrid'),
);

export const setRiskNullScore = createAction<number>(
	addNamespace('Util/setRiskNullScore'),
);

export const setRiskStatus = createAction<string>(
	addNamespace('Util/setRiskStatus'),
);

export const setRiskRunning = createAction<boolean>(
	addNamespace('Util/setRiskRunning'),
);

export const setRiskLastRun = createAction<string>(
	addNamespace('Util/setRiskLastRun'),
);

export const setDataGridState = createAction<DataGridStateChange>(
	addNamespace('dataGrid/state'),
);
